module.exports = __webpack_public_path__ + "assets/img/category.6f8e8229.png";